import { render, staticRenderFns } from "./BargeLogisticMonitoring.vue?vue&type=template&id=007116fe&scoped=true&"
import script from "./BargeLogisticMonitoring.vue?vue&type=script&lang=js&"
export * from "./BargeLogisticMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./BargeLogisticMonitoring.vue?vue&type=style&index=0&id=007116fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007116fe",
  null
  
)

export default component.exports